"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
var pino_1 = __importDefault(require("pino"));
var environment_1 = require("./environment");
function getLogLevel() {
    if (process.env.LOG_LEVEL) {
        return process.env.LOG_LEVEL;
    }
    // Way too much activity when testing to see anything but issues
    if (environment_1.IS_TEST) {
        return "warn";
    }
    if (environment_1.IS_DEVELOPMENT) {
        return "debug";
    }
    // Effectively in production
    return "info";
}
exports.logger = (0, pino_1.default)({
    level: getLogLevel(),
    prettyPrint: environment_1.IS_DEVELOPMENT || environment_1.IS_TEST,
});
